/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SmsClient } from '../model/smsClient';
import { SmsUserServiceWalletResponse } from '../model/smsUserServiceWalletResponse';
import { WalletResponseDto } from '../model/walletResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsClientService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param creatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetClientByCreatorId(creatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsClient>;
    public smsClientGetClientByCreatorId(creatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsClient>>;
    public smsClientGetClientByCreatorId(creatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsClient>>;
    public smsClientGetClientByCreatorId(creatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsClient>(`${this.basePath}/api/SmsClient/GetClientByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasProviderId 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetClientWalletBalance(vasProviderId?: string, serviceId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsUserServiceWalletResponse>>;
    public smsClientGetClientWalletBalance(vasProviderId?: string, serviceId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsUserServiceWalletResponse>>>;
    public smsClientGetClientWalletBalance(vasProviderId?: string, serviceId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsUserServiceWalletResponse>>>;
    public smsClientGetClientWalletBalance(vasProviderId?: string, serviceId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (vasProviderId !== undefined && vasProviderId !== null) {
            queryParameters = queryParameters.set('vasProviderId', <any>vasProviderId);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SmsUserServiceWalletResponse>>(`${this.basePath}/api/SmsClient/GetClientWalletBalance`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasProviderId 
     * @param smsRouteName 
     * @param smsCostingCount 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetClientWalletBalanceForAServiceByRoute(vasProviderId?: string, smsRouteName?: string, smsCostingCount?: number, observe?: 'body', reportProgress?: boolean): Observable<WalletResponseDto>;
    public smsClientGetClientWalletBalanceForAServiceByRoute(vasProviderId?: string, smsRouteName?: string, smsCostingCount?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletResponseDto>>;
    public smsClientGetClientWalletBalanceForAServiceByRoute(vasProviderId?: string, smsRouteName?: string, smsCostingCount?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletResponseDto>>;
    public smsClientGetClientWalletBalanceForAServiceByRoute(vasProviderId?: string, smsRouteName?: string, smsCostingCount?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (vasProviderId !== undefined && vasProviderId !== null) {
            queryParameters = queryParameters.set('vasProviderId', <any>vasProviderId);
        }
        if (smsRouteName !== undefined && smsRouteName !== null) {
            queryParameters = queryParameters.set('smsRouteName', <any>smsRouteName);
        }
        if (smsCostingCount !== undefined && smsCostingCount !== null) {
            queryParameters = queryParameters.set('smsCostingCount', <any>smsCostingCount);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<WalletResponseDto>(`${this.basePath}/api/SmsClient/GetClientWalletBalanceForAServiceByRoute`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasProviderId 
     * @param serviceTypeBasedOnTelcoType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe?: 'body', reportProgress?: boolean): Observable<WalletResponseDto>;
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletResponseDto>>;
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletResponseDto>>;
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (vasProviderId !== undefined && vasProviderId !== null) {
            queryParameters = queryParameters.set('vasProviderId', <any>vasProviderId);
        }
        if (serviceTypeBasedOnTelcoType !== undefined && serviceTypeBasedOnTelcoType !== null) {
            queryParameters = queryParameters.set('serviceTypeBasedOnTelcoType', <any>serviceTypeBasedOnTelcoType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<WalletResponseDto>(`${this.basePath}/api/SmsClient/GetWalletBalaceForAServiceTypeForAclient`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
